module.exports = __webpack_public_path__ + "img/00024.59d61885.webp";